import type { CommandeListee } from '../api/types';
import { formatCourt } from '../format';

/**
 * Les relances déjà parties par mail, à rouvrir dans Outlook.
 *
 * C'est ce que promettait « Ouvrir dans ma messagerie », qui n'ouvrait en
 * réalité qu'un NOUVEAU mail pré-rempli, jamais celui qui était parti. Ici, le
 * lien mène au message envoyé depuis contact@, tel qu'Outlook le garde.
 *
 * Les relances d'avant l'enregistrement du lien restent listées, sans lien :
 * elles ont eu lieu, on ne sait simplement plus les rouvrir d'ici.
 */
export function RelancesEnvoyees({
  commande, cible,
}: {
  commande: CommandeListee;
  cible: 'fournisseur' | 'transporteur';
}) {
  const relances = commande.relancesEnvoyees.filter((r) => r.cible === cible);
  if (!relances.length) return null;

  return (
    <div className="field">
      <label>Déjà relancé par mail</label>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, fontSize: 12.5 }}>
        {relances.map((r, i) => (
          <li key={i} style={{ display: 'flex', gap: 10, alignItems: 'baseline', marginBottom: 4 }}>
            <span className="mono">{r.le ? formatCourt(r.le) : '—'}</span>
            <span style={{ color: 'var(--ink-3)', flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>
              {r.destinataires ?? ''}
            </span>
            {r.lienWeb
              ? <a href={r.lienWeb} target="_blank" rel="noreferrer">Ouvrir dans Outlook</a>
              : <span style={{ color: 'var(--ink-3)' }} title="Envoyée avant que l'application n'enregistre le lien du mail.">lien non conservé</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
